import axiosClient from "./axiosClient";
import { CheckNullParams } from "../utils/CheckNullParams";

const shippingApi = {
  getShipping: () => {
    const url = "shipping-provider";
    return axiosClient.get(url);
  },

  updateShipping: (params) => {
    const url = "shipping-provider";
    const payload = CheckNullParams(params);
    return axiosClient.post(url, payload);
  },
  createNote: (params) => {
    const url = "shipping-provider/create-note";
    const payload = CheckNullParams(params);
    return axiosClient.post(url, payload);
  },
  deleteNote: (params) => {
    const url = "shipping-provider/delete-notes";
    return axiosClient.delete(url, { params });
  },
};

export default shippingApi;
